// src/components/Portfolio/DeficienciesObjects/GreenTeaExtract.js

const Diaet = {
  productCode: "SBOVZ-DHS",
  productName: "Diaet BS",
  ingredients: "Gymnema sylvestre, Lagerstroemia speciosa, Salacia reticulata ",
  overview:"Botanical and whole food Vitamin Supplement for Diabetes Health",
  assay:"Zinc: 4 mg; Chromium: 16 mcg; Selenium: 13 mcg; Vitamin D3: 200 IU; B12-Corrinoids: 0.73 mcg; Gymnema sylvestre extract: 166 mg, Lagerstroemia speciosa extract: 166 mg; Salacia reticulata extract: 66 mg",
  coNutrients:"Nutrients like corosolic acid, Ellagitannins,Triterpene saponins, Polyphenols from Gymnema and Banaba will help improve weight management, inhibit fat-metabolizing enzymes.",
  
  benefits:" Diaet whole-food supplement helps inhibit glucosidase enzyme and lowers blood sugar, improves insulin production and suppress appetite with the help of 75% Gymnemic acid. Banaba extract helps with inhibitory effect on postprandial hyperglycemia. Salacia reticulata improves abnormal glucose tolerance, fatty degeneration of hepatocytes and anti-obesity effect. The vitamins and minerals present in DIAET help improve insulin sensitivity. Natural Cobalamin co-factors in Shiitake Vitamer Complex (B12-Corrinoids) improve the symptoms of peripheral neuropathy and provide an overall nutritional balance to diabetes condition.",
  functionalUse: {
    main: "💊︎ Capsule",
    note: "(Note:- heat and light sensitive, prone to oxidative stress)"
  },
  bannerImage: [
    "images/Portfolio/OrgavitazForConditions/Diaet.png"
    

  ],
  certificates: [
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L1.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L2.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L3.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L4.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L6.png",

  ]
};

export default Diaet;
